export default __webpack_public_path__ + "static/Electrical_Cable_Intersection-cbf4b7f90f8541df214e0c9a265dc385.png";